<template>
  <v-card>
    <v-card-title class="text-h6">
      {{ $t("Chấm công") }}
      <v-spacer></v-spacer>
      <v-btn small color="red darken-1" text @click="cancel">
        {{ $t("Đóng") }}
      </v-btn>
    </v-card-title>

    <v-card-text>
      <div>
        <v-simple-table
          fixed-header
          height="60vh"
          class="table-padding-2 table-h-36"
        >
          <template v-slot:default>
            <thead class="v-data-table-header">
              <tr>
                <th role="columnheader" class="text-center">Ngày</th>
                <th role="columnheader" class="text-center">Đến</th>
                <th role="columnheader" class="text-center">Về</th>
                <th role="columnheader" class="text-center">T.Gian làm việc</th>
              </tr>
            </thead>
            <tbody>
              <tr class="text-center" v-for="item in items" :key="item.id">
                <td>{{ formatDateTime(item.check_date, "DD/MM/YYYY") }}</td>
                <td>{{ item.checkin_time }}</td>
                <td>{{ item.checkout_time }}</td>
                <td>
                  <SecondToHumanTime :value="item.work_second" />
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>

        <v-row class="pt-3">
          <v-col cols="2"></v-col>
          <v-col cols="8">
            <v-pagination
              v-model="page"
              :length="totalPage"
              :total-visible="6"
            ></v-pagination>
          </v-col>
          <v-col cols="2"></v-col>
        </v-row>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { httpClient } from "@/libs/http";
import { debounce } from "lodash";

export default {
  name: "TimekeepingAccountList",
  components: {
    SecondToHumanTime: () =>
      import("@/components/common/SecondToHumanTime.vue"),
  },
  props: {},
  data: () => ({
    page: 1,
    totalPage: 1,
    filters: {},
    items: [],
  }),
  computed: {},
  watch: {
    page() {
      this.getList();
    },
    filters: {
      handler() {
        this.page = 1;
        this.getList();
      },
      deep: true,
    },
  },
  created() {},
  mounted() {
    this.getList();
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    getList: debounce(function () {
      httpClient
        .post("/me/v1/timekeeping-account-list", {
          ...this.filters,
          page: this.page,
        })
        .then(({ data }) => {
          this.totalPage = data.totalPage;
          this.items = [...data.rows];
        });
    }, 500),
  },
};
</script>

<style scoped></style>
